import AbstractShape from "../shapes/shapes/AbstractShape";
import { ADD_SPECIES_TO_ELEMENT, DELETE } from "../tools/actions/ActionHelper";
import AbstractProvidedClass from "./AbstractProvidedClass";

export default class Selection extends AbstractProvidedClass {
    collection = [];

    add(element) {
        element.select();
        this.collection.push(element);
        if (!this.infoTab.currentElement) {
            this.infoTab.setCurrentElement(element);
        }
        this.infoTab.update();
    }

    remove(element) {
        element.deselect();
        this.collection = this.collection.filter((p) => p != element);
        if (this.infoTab.currentElement == element) {
            let nextElement = this.collection[0];
            this.infoTab.setCurrentElement(nextElement);
        }
        this.infoTab.update();
    }

    select(element) {
        this.reset();
        Array.isArray(element)
            ? element.map((e) => this.add(e))
            : this.add(element);
    }

    reset() {
        this.drawMenu?.hide();
        this.collection.map((s) => s.deselect());
        this.collection = [];
        this.infoTab.setCurrentElement();
        this.infoTab.update();
    }

    delete() {
        this.actions.execute(DELETE, this.collection);
        this.reset();
    }

    get first() {
        return this.collection[0];
    }

    get items() {
        return this.collection;
    }

    drag(x, y) {
        this.collection.map((s) => s.drag(x, y));
    }

    clone() {
        let [absCenterX, absCenterY] = this.determineCenter();
        let absGridMinorSize = this.grid.minorSize / this.view.scale;
        absCenterX = Math.round(absCenterX / absGridMinorSize) * absGridMinorSize;
        absCenterY = Math.round(absCenterY / absGridMinorSize) * absGridMinorSize;
        this.tools.setTool(
            'placement',
            this.collection.map(
                (s) => s.clone(-absCenterX, -absCenterY)
            ),
        );
    }

    copy() {
        let [absCenterX, absCenterY] = this.determineCenter();
        let returnData = {
            elements: [],
            species: {},
        };
        this.collection.map((s) => {
            returnData.elements.push(s.clone(-absCenterX, -absCenterY).export());
            s.speciesIds.map((id) => {
                returnData.species[id] = this.speciesCollection.get(id);
            });
        });
        return returnData;
    }

    determineCenter() {
        let minX, maxX, minY, maxY;
        this.collection.map((s) => {
            minX = minX ? Math.min(minX, s.absMinX) : s.absMinX;
            maxX = maxX ? Math.max(maxX, s.absMaxX) : s.absMaxX;
            minY = minY ? Math.min(minY, s.absMinY) : s.absMinY;
            maxY = maxY ? Math.max(maxY, s.absMaxY) : s.absMaxY;
        });
        return [minX + (maxX - minX) / 2, minY + (maxY - minY) / 2];
    }

    hovered() {
        return this.length == 1
            ? this.collection[0].hoveredWithSupport()
            : this.collection.find((s) => s.hovered());
    }

    mouseOver() {
        return this.collection.findLast((s) => s.mouseOver());
    }

    click(element) {
        Array.isArray(element)
            ? this.clickSet(element)
            : this.clickSingle(element);
    }

    clickSet(elements) {
        if (this.p.keyIsDown(this.p.CONTROL)) {
            elements.map((element) => {
                if (!element.selected) {
                    this.add(element);
                }
            });
        } else if (this.p.keyIsDown(this.p.SHIFT)) {
            elements.map((element) => {
                if (element.selected) {
                    this.remove(element);
                }
            });
        } else {
            this.select(elements);
        }
    }

    clickSingle(element) {
        if (!(element instanceof AbstractShape)) {
            return this.clickSingle(element.parent);
        }
        if (this.p.keyIsDown(this.p.CONTROL)
            || this.p.keyIsDown(this.p.SHIFT)
        ) {
            if (element.selected) {
                this.remove(element);
            } else {
                this.add(element);
            }
        } else {
            this.select(element);
        }
    }

    addSpecies(species) {
        this.actions.execute(ADD_SPECIES_TO_ELEMENT, this.collection, species);
    }

    get species() {
        return this.collection.reduce((species, element) => {
            species[element.species.id] = element.species;
            return species;
        }, {});
    }

    get selected() {
        return this.length > 0;
    }

    get length() {
        return this.collection.length;
    }

    get infoTab() {
        return this.sideBar.tabs['info'];
    }
}
